<template>
  <div>
    <nav-common :nav="nav"></nav-common>
    <div class="center-intro">
      <div class="center-intro-content">
        <child-detail :detail="detail"></child-detail>
      </div>
    </div>
  </div>
</template>
<style scoped>
.center-intro {
  width: 100%;
  background: #e6ecf2;
  border: 1px solid #e6ecf2;
  box-sizing: border-box;
  border-radius: 10px 10px 0 0;
  padding: 20px 0 0 0;
  box-sizing: border-box;
}
.center-intro-content {
  width: 100%;
  background: #fff;
  color: #222;
  padding: 40px;
  box-sizing: border-box;
}
</style>

<script>
import navCommon from "@/components/views/common/nav.vue";
import childDetail from "./childDetail.vue";
import { userApi } from "@/api/user.js";
export default {
  data() {
    return {
      nav: {
        firsttitle: "中心概况",
        firstrouteName: "centerCate",
        secondtitle: "资质证书",
        secondrouteName: "",
        thirdtitle: "",
        thirdrouteName: ""
      },
      detail: {}
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      userApi.organizationdetail({ type: 5 }).then(res => {
        this.detail = res.data;
      });
    }
  },
  components: {
    navCommon,
    childDetail
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/Organization/Children/centerCate.vue